import {
    Box,
    VStack,
    Text,
    Input,
    Button,
    Image,
} from "@chakra-ui/react";

import {
    useState,
} from "react";

import {
    useNavigate,
} from "react-router-dom";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Logo from "../../../../assets/logo.png";
import routes from "../../../../routes";

import {
    passwordResetAction,
} from "../../../../state/actions/authActions";

import {
    toaster,
} from "../../../../components/toaster";

import ActivityToast from "../../../../components/ActivityToast";

const ForgotPasswordForm = () => {
    const navigate =
        useNavigate();

    const dispatch =
        useDispatch();

    const {
        loading,
    } = useSelector(
        (state) =>
            state.auth
    );

    const [
        email,
        setEmail,
    ] = useState("");

    const handleSubmit =
        async () => {
            const result =
                await dispatch(
                    passwordResetAction(
                        email
                    )
                );

            if (
                result?.success
            ) {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="success"
                            title="OTP Sent"
                            description="We've sent a verification code to your email address."
                            timestamp="Just now"
                        />
                    ),
                });

                setTimeout(() => {
    navigate(
        routes.resetPasswordConfirm,
        {
            state: {
                user_id:
                    result?.data?.user_id,
                email,
            },
        }
    );
}, 1000);
            } else {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="error"
                            title="Reset Failed"
                            description={
                                result?.error ||
                                "Unable to process your request."
                            }
                            timestamp="Just now"
                        />
                    ),
                });
            }
        };

    return (
        <Box p={20}>
            <Box textAlign="center">
                <Image
                    src={Logo}
                    h="48px"
                    mb={12}
                    mx="auto"
                    cursor="pointer"
                    onClick={() =>
                        navigate(
                            routes.home
                        )
                    }
                />

                <Text
                    fontSize={{
                        base: "32px",
                        md: "48px",
                    }}
                    fontWeight="700"
                    color="#071D54"
                    mb={2}
                >
                    Forgot Password?
                </Text>

                <Text
                    color="gray.600"
                    mb={10}
                    maxW="450px"
                    mx="auto"
                >
                    Enter your email address
                    and we'll send you
                    instructions to reset
                    your password.
                </Text>
            </Box>

            <VStack gap={5}>
                <Input
                    placeholder="name@company.com"
                    size="lg"
                    type="email"
                    value={email}
                    onChange={(e) =>
                        setEmail(
                            e.target.value
                        )
                    }
                />

                <Button
                    w="100%"
                    size="lg"
                    bg="#2453FF"
                    color="white"
                    loading={loading}
                    loadingText="Sending..."
                    _hover={{
                        bg: "#1B46E5",
                    }}
                    disabled={
                        !email.trim()
                    }
                    onClick={
                        handleSubmit
                    }
                >
                    Send Reset Link
                </Button>
            </VStack>

            <Text
                mt={12}
                textAlign="center"
                color="#2453FF"
                cursor="pointer"
                fontWeight="600"
                onClick={() =>
                    navigate(
                        routes.login
                    )
                }
            >
                ← Back to Login
            </Text>
        </Box>
    );
};
export default ForgotPasswordForm;